import {css} from "@emotion/css";
import Checkbox from "@mui/material/Checkbox";
import {FormControlLabel} from "@mui/material";
import * as React from "react";
import "./RaikoCheckbox.scss"

const RaikoCheckbox = ({label, setChecked, checked}) => {

    const handleChange = (event) => {
        setChecked(event.target.checked);
    };

    return (
        <div className={css`width: 100%;
          padding: 0 1rem 1rem 1rem;`}>
            <FormControlLabel control={<Checkbox/>} checked={checked} onChange={handleChange} label={label}/>
        </div>
    )
}
export default RaikoCheckbox;